import config from "../config";
import Button from "./common/F7/Button";
import { FC, useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Logo from "../images/logo.svg";
import { useSetJWT } from "../state";

const LoginModal: FC = () => {
  const setJwt = useSetJWT();
  const location = useLocation();
  // watch for JWTs in the URL, store it and redirect home if present
  useEffect(() => {
    const match = location.pathname.match(/\/jwt\/([a-zA-Z0-9-_]*\.[a-zA-Z0-9-_]*\.[a-zA-Z0-9-_]*)$/);
    if (match) {
      setJwt(match[1]);
    }
  }, [location, setJwt]);

  const handleClick = useCallback(() => {
    if (config.isApp) {
      // TODO: replace cordova usage
      // var browserRef  = cordova.InAppBrowser.open(loginUrl, '_blank', 'location=yes,clearsessioncache=yes,clearcache=yes');
      // browserRef.addEventListener('loadstop', browserLoadstopHandler(browserRef, loginUrl, deferred));
    } else {
      const returnUrl = window.location.origin + window.location.pathname + "#/jwt/";
      window.location.assign(config.auth + "?redirect=" + encodeURIComponent(returnUrl));
    }
  }, []);

  return (
    <div
      style={{
        backgroundColor: "rgba(255,255,255, 1)",
        width: "100vw",
        height: "100vh",
      }}
    >
      <div className="view">
        <div
          className="page"
          style={{
            backgroundColor: "rgba(255,255,255, 1)",
          }}
        >
          <div
            className="page-content login-screen-content"
            style={{
              backgroundColor: "rgba(255,255,255, 1)",
            }}
          >
            <div
              style={{
                backgroundColor: "rgb(254, 254, 254)",
                position: "fixed",
                top: 0,
                width: "100%",
                height: 65,
              }}
            />
            <div className="list-block-label">
              <img
                src={Logo}
                style={{
                  width: 100,
                  marginTop: 60,
                  marginBottom: -30,
                }}
                alt=""
              />
            </div>
            <div
              style={{
                padding: 15,
                marginTop: 10,
              }}
              className="login-screen-title"
            >
              Piano
            </div>

            <div className="list-block">
              <ul>
                <li
                  style={{
                    marginBottom: 20,
                  }}
                >
                  <Button onClick={handleClick}>Login</Button>
                </li>
              </ul>
            </div>
            <div
              style={{
                backgroundColor: "rgb(254, 254, 254)",
                position: "fixed",
                bottom: 0,
                width: "100%",
                height: 45,
              }}
            >
              <div
                style={{
                  textAlign: "center",
                }}
              >
                v{config.version}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
